type GetPromoPriceArgs = {
  discountAmount?: number;
  cashbackAmount?: number;
  price: number;
};

export function getPromoPrice({
  discountAmount,
  cashbackAmount,
  price,
}: GetPromoPriceArgs) {
  const formatter = new Intl.NumberFormat('id-ID');

  const finalPrice = (() => {
    if (discountAmount) return Math.floor(price - price * discountAmount);
    if (cashbackAmount) return price - cashbackAmount;
    return price;
  })();

  return {
    formatter,
    finalPrice,
    price,
  };
}
